<template>
  <div id="app" class="main">
    <div class="left">
      <div class="title">E识别图片比对监测平台</div>
      <div class="sub-title">24小时对您的创作成果定向全网监测</div>
    </div>
    <div class="right">
      <div class="title">E识别图片比对监测平台</div>
      <div class="box">
        <div class="register padding-lr-20">
          <a href="register">立即注册</a>
        </div>
        <div class="login_box">
          <div class="title_login">
            登录
            <img :src="type==1?'static/images/qr_code.png':'static/images/phone.png'" @click="loginType" />
            <span style="color:green">{{type == 1? '微信扫码登录':'账号密码登录'}}</span>
          </div>


          <div v-if="type==2">
            <iframe class="login_iframe" :src="formUrl" scrolling="no" width="" height=""></iframe>
          </div>

          <div v-if="type==1">
            <div class="login_field">
              <el-input
                placeholder="请输入手机号"
                v-model="ruleForm.account"
                clearable>
              </el-input>
            </div>

            <div class="login_field">
              <el-input
                placeholder="请输入密码"
                v-model="ruleForm.pwd"
                show-password
                @keyup.enter.native="login"
                >
              </el-input>
            </div>

            <div class="btn_login">
              <input value="登录" type="button" @click="login" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { loginApi,wxLoginApi,monitoringApi } from '../service/allApi';
export default {
  name: "Register", 
  data(){
    return {
      ruleForm:{
        account:"",
        pwd:""
      },
      type:1,
      formUrl:'',
      a:null
    }
  },
  methods:{
    async login(){
      let pass = true
      if(!this.checkMobile(this.ruleForm.account)){
        pass = false
        //alert("请输入正确的手机号码");
        this.$message({
          type: 'error',
          message: '请输入正确的手机号码'
        })
      }
      if(pass && this.ruleForm.pwd.length < 6){
        pass = false
        this.$message({
          type: 'error',
          message: '密码长度不能少于6个字符'
        })
       
      }

      //呈现加载
      const loading = this.$loading({
                  lock: true,
                  text: 'Loading',
                  spinner: 'el-icon-loading',
                  background: 'rgba(0, 0, 0, 0.7)'
                });

      if(pass){
        const res = await loginApi(this.ruleForm)
        if(res.data.code === 100){
          localStorage.setItem("user",JSON.stringify(res.data.data));
          var user = JSON.stringify(res.data.data);
          loading.close();
          this.$router.push('/')

        }else{
          loading.close();
          this.$message({
          type: 'error',
          message: res.data.msg
        })
        }
      }
    },
        // 验证手机号
    checkMobile(str) {
      let re = /^1\d{10}$/
      if (re.test(str)) {
        return true;
      } else {
        return false;
      }
    },
   async loginType(){
     var that = this
     //微信登录
      if(that.type==1){
        var res = await wxLoginApi();
        if(res.data!=null){
            that.formUrl = res.data
        } 
      }
      that.type =  that.type == 1?2:1;
    },
   
  }
}
</script>
<style scoped>
.main {
  background-color: #fff;
  width: 100%;
  height: 100%;
}
.main .left {
  width: 60%;
  height: 710px;
  float: left;
  background-image: url("/static/images/login_bg.png");
}
.main .left div {
  color: #fff;
  margin-left: 164px;
  text-align: center;
}
.main .left div.title {
  margin-top: 370px;
  font-size: 55px;
}
.main .left div.sub-title {
  font-size: 36px;
}
.main .right {
  float: right;
  width: 40%;
}
.main .right .title {
  color: #5353ce;
  font-size: 28px;
  text-align: center;
  margin-top: 159px;
}
.main .right .box {
  margin: 0 auto;
  width: 450px;
}
.padding-lr-20 {
  padding: 0px 20px;
}
.main .right .box .register {
  text-align: right;

  font-size: 15px;
  margin-top: 33px;
}
.main .right .box .register a {
  color: #ff3434;
  text-decoration: none;
}
.login_box {
  background-image: url("/static/images/login_box.png");
  height: 430px;
}
.title_login {
  text-align: center;
  font-size: 20px;
  padding-top: 20px;
  line-height: 40px;
  padding-bottom: 5px;
  border-bottom: #e6e6ee 1px solid;
  margin: 0 auto;
  width: 424px;
}
.title_login img {
  float: right;
  width: 38px;
  height: 38px;
  margin-right: 8px;
}
.title_login span{
  float: right;
  font-size:10px;
}
.login_field {
  width: 345px;
  margin: 0 auto;
  padding: 50px 5px 10px 5px;
  color: #808080;
  font-size: 12px;
  border-bottom: #e6e6ee 1px solid;
}
.login_field .field {
  width: 100px;
  display: inline-block;
}
.login_field input {
  border: none;
  width: 230px;
}
.btn_login {
  margin: 0 auto;
  margin-top: 50px;
  width: 347px;
  height: 44px;
}
.btn_login input {
  color: #fff;
  width: 100%;
  height: 100%;
  font-size: 20px;
  border: none;
  background-color: #5353ce;
  border-radius: 4px;
  cursor: pointer;
}
.login_iframe{
				width: 100%;border: none;display: block;height: 4rem;
        height: 400px;
    }
</style>


// WEBPACK FOOTER //
// src/components/Login.vue